import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan, inputChangeBegan } from './api';


const slice = createSlice({
  name: 'paxSearch',
  initialState: {
    airline: '',
    searchResults: [],
    loading: false,
    changingInput: false,
    lastName: "",
    fistName: "",
    date: "",
    pnr: ""
  },

  reducers: {
    setAirline: (state, action) => {
      state.airline = action.payload
    },

    searchRequested: (state, action) => {
      state.loading = true;
    },

    searchSuccess: (state, action) => {
      state.searchResults = action.payload;
      state.loading = false;
    },

    searchError: (state, action) => {
      state.loading = false;
      console.log(`search pax err: ${action.payload}`);
    },

    inputChanged: (state, action) => {
      action.payload.type === "pnr" ? 
        state[action.payload.type] = action.payload.data.toUpperCase() : 
        state[action.payload.type] = action.payload.data;
      state.changingInput = false;
    },

    inputChangeRequested: (state, action) => {
      state.changingInput = true;
    }
  }
})

// NOTE // actions for use in api requests
const { searchSuccess, searchError, searchRequested, inputChanged, inputChangeRequested } = slice.actions;
export const { setAirline } = slice.actions;
// NOTE // actions for use in components
export default slice.reducer;

export const searchPax = (payload) => (dispatch, getState) => {
  const url = `paxSearch`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {lastName: payload.lastName, firstName: payload.firstName || null, date: payload.date || null, airlineId: getState().entities.paxSearch.airline},
      onStart: searchRequested.type,
      onSuccess: searchSuccess.type,
      onError: searchError.type,
    })
  )
}

export const searchPnr = (pnr) => (dispatch, getState) => {
  const url = `paxSearch/pnr`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {pnr, airlineId: getState().entities.paxSearch.airline},
      onStart: searchRequested.type,
      onSuccess: searchSuccess.type,
      onError: searchError.type,
    })
  )
}

export const changeInput = (payload) => (dispatch) => {
  return dispatch(
    inputChangeBegan({
      data: payload,
      onStart: inputChangeRequested.type,
      onSuccess: inputChanged.type,
      onError: inputChanged.type
    })
  )
}